import SearchIndex from "shared/lib/search_index"
import trim from "lodash/trim"

export default class ServiceSearch {
  constructor(docs) {
    this.index = new SearchIndex()

    docs.forEach(doc => {
      this.index.add(doc.id, doc.name, [doc.module_name, doc.category])
    })

    this.el = document.querySelector("#service-search")

    const onSearch = this.onSearch.bind(this)
    this.el.addEventListener("keyup", onSearch)
  }

  onSearch() {
    const query = trim(this.el.value)

    if (query === "") {
      return this._showAllCards()
    }

    const serviceIds = this.index.search(query)
    this._updateCards(serviceIds)
  }

  _updateCards(results) {
    const refs = results.map(result => {
      return `#service-${result}`
    })

    document.querySelector(".all-categories").style.display = "none"
    document.querySelector(".all-services").style.display = "block"
    document.querySelectorAll(".all-services .service-tile").forEach(box => {
      box.style.display = "none"
    })

    if (refs.length > 0) {
      document
        .querySelector(".all-services")
        .querySelectorAll(refs.join(","))
        .forEach(box => {
          box.style.display = "flex"
        })
    }

    // Hack: Force resize to update flex
    window.dispatchEvent(new Event("resize"))
  }

  _showAllCards() {
    document.querySelector(".all-categories").style.display = "block"
    document.querySelectorAll(".all-services .service-tile").forEach(box => {
      box.style.display = "none"
    })
    document.querySelector(".all-services").style.display = "none"

    // Hack: Force resize to update flex
    window.dispatchEvent(new Event("resize"))
  }
}
